<template>
  <div id="app">
    <a-locale-provider :locale="app_locale">
      <router-view />
    </a-locale-provider>
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import en_US from "ant-design-vue/lib/locale-provider/en_US";
import th_TH from "ant-design-vue/lib/locale-provider/th_TH";
import moment from "moment";
import { ConfigProvider } from "ant-design-vue";
import "moment/locale/zh-cn";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    "a-locale-provider": ConfigProvider,
  },
  computed: {
    ...mapState(["lang", "locale"]),
    app_locale() {
      return this.locale || zh_CN;
    },
  },
  mounted() {
    moment.locale(this.lang);
    this.$bus.$on("change-lang", (lang) => {
      let locale = zh_CN;
      this.$i18n.locale = lang;
      moment.locale(lang);
      switch (lang) {
        case "zh":
          locale = zh_CN;
          break;
        case "en":
          locale = en_US;
          break;
        case "th":
          locale = th_TH;
          break;
        default:
          locale = zh_CN;
          break;
      }
      this.setState({
        lang,
        locale,
      });
    });
  },
  methods: {
    ...mapMutations(["setState"]),
  },
};
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
}
</style>

<style lang="scss">
@import "./assets/css/common.scss";
</style>
